// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import user from 'Pages/Auth/store'
import cart from './public'

export const reducers = {
  navbar,
  layout,
  user,
  cart
}
